module.exports = __webpack_public_path__ + "components/layout/images/tel.png?78466718";


//////////////////
// WEBPACK FOOTER
// ./components/layout/images/tel.png
// module id = 244
// module chunks = 0